<template>
  <div class="app-container">
    <div class="app-content">
      <el-card shadow="nerver" class="manager-page">
        <template slot="header">
          <el-form label-width="80px" size="small">
            <el-form-item :label="$t('text.yhmc')">
              <el-input
                v-model="queryParams.username"
                clearable
              />
            </el-form-item>
            <el-form-item :label="$t('text.qymc')">
              <el-input
                v-model="queryParams.company"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                :loading="loading"
                @click="handleQuery"
              >{{ $t('button.cx') }}</el-button>
              <el-button
                v-permission="[1,2]"
                icon="el-icon-plus"
                type="primary"
                @click="handleAdd"
              >{{ $t('button.tianjia') }}</el-button>
              <el-button
                v-permission="[3]"
                type="primary"
                icon="el-icon-plus"
                @click="openCreate"
              >{{ $t('button.cjzd') }}</el-button>
            </el-form-item>
          </el-form>
        </template>

        <template slot="default">
          <el-table
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.7)"
            :data="tableData"
            height="calc(100% - 50px)"
          >
            <el-table-column
              align="center"
              width="68px"
              type="index"
              :label="$t('text.xh')"
            />
            <el-table-column
              align="center"
              prop="username"
              :label="$t('text.yhm')"
            />

            <el-table-column
              align="center"
              prop="rolename"
              :label="$t('text.jsm')"
            />
            <el-table-column
              align="center"
              prop="mobile"
              :label="$t('text.sj')"
            />
            <el-table-column
              align="center"
              prop="email"
              :label="$t('text.yx')"
            />
            <el-table-column
              align="center"
              prop="company"
              :label="$t('text.gs')"
            />
            <el-table-column
              align="center"
              prop="createtime"
              :label="$t('text.zcsj')"
            >
              <template v-slot="scope">
                <span>{{ scope.row.createtime | dateFilter('yyyy-MM-dd hh:mm:ss') }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              width="201px"
              :label="$t('text.cz')"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  icon="el-icon-edit"
                  @click="handleEdit(scope.row)"
                >{{ $t('button.bj') }}</el-button>
                <el-button
                  v-permission="[1]"
                  type="text"
                  class="warning"
                  size="small"
                  icon="el-icon-refresh"
                  @click="handleReset(scope.row)"
                >{{ $t('button.czmm') }}</el-button>
                <el-button
                  type="text"
                  class="danger"
                  size="small"
                  icon="el-icon-delete"
                  @click="handleDelete(scope.row)"
                >{{ $t('button.sc') }}</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            v-show="total>0"
            background
            layout="total, prev, pager, next, jumper"
            :total="total"
            :page-size.sync="pageSize"
            :current-page.sync="pageNum"
            @current-change="getTableData"
          />
        </template>
      </el-card>
      <!-- 编辑弹出框 -->
      <el-dialog
        width="30%"
        :title="$t('text.yhbj')"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
      >
        <el-form label-width="100px">
          <el-form-item :label="$t('text.yhm')">
            <el-input
              v-model="edit.username"
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item :label="$t('text.sj')">
            <el-input
              v-model="edit.mobile"
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item :label="$t('text.yx')">
            <el-input
              v-model="edit.email"
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item :label="$t('text.gs')">
            <el-input
              v-model="edit.company"
              autocomplete="off"
            />
          </el-form-item>
          <div class="text-center">
            <el-button
              type="primary"
              @click="handleUpdate"
            >{{ $t('button.qd') }}</el-button>
          </div>
        </el-form>
      </el-dialog>
      <!-- 添加用户弹出框 -->
      <el-dialog
        :title="addUserDialogTitle"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
      >
        <el-form label-width="100px">
          <el-form-item :label="$t('text.yhm')">
            <el-input
              v-model="add.username"
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item :label="$t('text.mm')">
            <el-input
              v-model="add.pwd"
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item :label="$t('text.sj')">
            <el-input
              v-model="add.mobile"
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item :label="$t('text.yx')">
            <el-input
              v-model="add.email"
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item :label="$t('text.gs')">
            <el-input
              v-model="add.company"
              autocomplete="off"
            />
          </el-form-item>
          <div class="text-center">
            <el-button
              type="primary"
              @click="addUser"
            >{{ $t('button.qd') }}</el-button>
          </div>
        </el-form>
      </el-dialog>
      <creatDialog :show-dialog.sync="showDialog" />
    </div>
  </div>
</template>

<script>
import { QueryUsersInfo, UpdateUserInfo, DeleteUserInfo, AddUserInfo, QueryDistributor, ResetPwd } from '@apis/Users'
import creatDialog from './components/createterminal.vue'
export default {
  components: {
    creatDialog
  },
  data () {
    return {
      queryParams: {},
      terminal: {},
      showDialog: false,
      options: [],
      roleOptions: [
        { label: '全部', value: '' },
        { label: '超级管理员', value: '1' },
        { label: '分销商', value: '2' },
        { label: '安装商', value: '3' },
        { label: '终端用户', value: '4' }
      ],
      loading: false,
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 15,
      exportLoading: null,
      editVisible: false,
      addVisible: false,
      parentOptions: [],
      edit: {},
      add: {
        roleid: '',
        username: '',
        mobile: '',
        pwd: '',
        email: '',
        company: ''
      }
    }
  },
  computed: {
    /** * 添加用户弹窗标题 */
    addUserDialogTitle () {
      let title = ''
      if (this.$store.getters.role === '1') {
        title = '添加分销商'
      }
      if (this.$store.getters.role === '2') {
        title = '添加安装商'
      }
      if (this.$store.getters.role === '3') {
        title = '添加终端用户'
      }
      return title
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    // 查询
    handleQuery () {
      this.pageNum = 1
      this.getTableData()
    },
    // 获取用户列表
    getTableData () {
      this.loading = true
      QueryUsersInfo({
        Page: this.pageNum,
        PerPage: this.pageSize,
        OrderBy: '',
        WhereCondition: JSON.stringify(this.queryParams)
      }).then(res => {
        this.total = res.data.totalCount
        this.tableData = res.data.queryResults || []
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 编辑按钮
    handleEdit (row) {
      this.editVisible = true
      this.edit = this.$deepClone(row)
    },
    // 更新用户信息
    handleUpdate () {
      UpdateUserInfo(this.edit)
        .then(() => {
          this.$message({
            type: 'success',
            message: this.$t('notice.xgyh')
          })
          this.handleQuery()
          this.editVisible = false
        })
    },
    // 删除按钮
    handleDelete (row) {
      this.$confirm(this.$t('notice.scyh'), this.$t('notice.title'), {
        type: 'warning'
      })
        .then(() => {
          DeleteUserInfo({
            id: row.id
          })
            .then(() => {
              this.$message({
                type: 'success',
                message: this.$t('notice.yhsccg')
              })
              this.handleQuery()
            })
        })
        .catch(() => {})
    },
    // 添加按钮
    handleAdd () {
      this.add = {
        roleid: '',
        parentuserid: '',
        username: '',
        mobile: '',
        pwd: '',
        email: '',
        company: ''
      }
      if (this.$store.getters.role === '1') {
        this.add.roleid = '2'
      } else if (this.$store.getters.role === '2') {
        this.add.roleid = '3'
      }
      this.addVisible = true
    },
    // 获取父级用户
    getParent (id) {
      this.add.parentuserid = ''
      QueryDistributor({
        id: id
      })
        .then(res => {
          this.parentOptions = res.data
        })
    },
    // 确认添加
    addUser () {
      AddUserInfo(this.add)
        .then(() => {
          this.$message({
            type: 'success',
            message: this.$t('notice.yhtjcg')
          })
          this.handleQuery()
          this.addVisible = false
        })
    },
    // 重置密码
    handleReset (row) {
      this.$confirm(this.$t('notice.czmm'), this.$t('notice.title'), {
        type: 'warning'
      })
        .then(() => {
          ResetPwd({
            id: row.id
          })
            .then(() => {
              this.$message({
                type: 'success',
                message: this.$t('notice.czcg')
              })
            })
        })
        .catch(() => {})
    },
    // 打开创建终端弹窗
    openCreate () {
      this.showDialog = true
    },
  }
}
</script>
<style scoped>
.manager-page{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: #1d3666;
  border-color: #1d3666;
}

.manager-page >>> .el-card__header{
  width: 100%;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
  background-color: #1d3666;
  border-color: #1d3666;
}
.manager-page >>> .el-card__header .el-form{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.manager-page >>> .el-card__header .el-form .el-form-item{
  margin-bottom: 0;
}

.manager-page >>> .el-card__body{
  width: 100%;
  height: calc(100% - 50px);
  padding: 15px 15px 0;
  box-sizing: border-box;
}
.manager-page >>> .el-card__body .el-table{
  width: 100%;
  box-sizing: border-box;
}
.manager-page >>> .el-card__body .el-pagination{
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

</style>
